const industries = [
    {
      icon: "fa-solid fa-gears",
      title: "CNC Machine Industry",
      desc: "Precision engineering industry producing automated cutting and shaping components.",
    },
    {
      icon: "fa-solid fa-flask",
      title: "Automation & Robotics",
      desc: "Innovative technology enabling intelligent, efficient, and precise automated operations.",
    },
    {
      icon: "fa-solid fa-bolt",
      title: "Packaging Industry",
      desc: "Industry focused on designing and producing protective product packaging solutions.",
    },
    {
      icon: "fa-solid fa-seedling",
      title: "Printing & Textile Machinery",
      desc: "Machinery industry specializing in advanced printing and textile production equipment.",
    },
    ];

    export default industries;